var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(!_vm.isLoading)?_c('div',[_c('vue-page-transition',{attrs:{"name":"fade-in-left"}},[_c('router-view')],1)],1):_vm._e(),_c('OverlayLoader',{attrs:{"show":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }